import { get, patch, post, remove } from '@/helpers/httpHandler';

export default {
  getContactsPersonsCompany: (_, { companyId }) => {
    return get(`work-profiles/contacts/${companyId}`);
  },

  getContactsPerson: (_, { contactPersonId }) => {
    return get(`work-profiles/${contactPersonId}`);
  },

  storeContactPerson: (_, { contactPerson }) => {
    return post('/work-profiles', contactPerson);
  },

  updateContactPerson: (_, { contactPersonId, contactPerson }) => {
    return patch(`/work-profiles/${contactPersonId}`, contactPerson);
  },

  destroyBlockTask: (_, { contactPersonId }) => {
    return remove(`/work-profiles/${contactPersonId}`);
  }
};
